import { CaravanIcon, CarIcon, TractorIcon, TruckIcon } from "lucide-react";
import type { ParsedBusiness } from "~/data/.server/business";

export function FleetItem(props: {
  fact?: string;
  icon?: React.ComponentType<{ className?: string }>;
}) {
  let { fact = "100%", icon: Icon } = props;
  Icon = Icon ?? CarIcon;

  return (
    <div className="flex aspect-square flex-col items-center justify-center rounded-sm border bg-muted p-2 text-center">
      <Icon className="size-20" />
      <span className="text-lg">
        <b>{fact}</b>
      </span>
    </div>
  );
}

export function FleetSection(props: { business: ParsedBusiness }) {
  const { business } = props;

  const { trucks, trailers, tractors } = business.company;
  const drivers = business.carrierInfo?.detail?.totalDrivers;

  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-4">
      <FleetItem icon={TruckIcon} fact={`${trucks} Trucks`} />
      <FleetItem icon={CaravanIcon} fact={`${trailers} Trailers`} />
      <FleetItem icon={TractorIcon} fact={`${tractors} Tractors`} />
      <FleetItem fact={`${drivers} Drivers`} />
    </div>
  );
}
